import { useContext } from 'react';
import {
  RoomSocketContext,
  RoomSocketContextType,
} from '../contexts/RoomSocketContext';

export function useRoomSocket(): RoomSocketContextType {
  const context = useContext(RoomSocketContext);
  if (!context) {
    throw new Error('useRoomSocket must be used within a RoomSocketProvider');
  }
  return context;
}
